import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { getFirebase, isLoaded, ReactReduxFirebaseProvider } from 'react-redux-firebase';
import firebase from '../Firebase/FireConfig';
import { createFirestoreInstance } from 'redux-firestore';
// import { useSelector } from "react-redux";
import rootReducer from "./reducer";
import { useSelector } from "react-redux";
import TodoLoading from "../components/TodoLoading";
import React from "react";

export const store = createStore(rootReducer, applyMiddleware(thunk.withExtraArgument({ getFirebase })));
export const rrfProps = {
    firebase,
    config: {},
    dispatch: store.dispatch,
    createFirestoreInstance
}
// const auth = useSelector((state: any) => state.firebase.auth);
// export const AuthIsLoaded = ( children: any ) => {
//     const auth = useSelector((state: any) => state.firebase.auth);
//     return(
//         (!isLoaded(auth)) 
//         ? <TodoLoading />
//         : children    
//     )
// }


// export const AuthIsLoaded = (children: any) => {
//     const auth = useSelector((state: any) => state.firebase.auth);
//     if (!isLoaded(auth))
//       return (
//         <TodoLoading />
//       );
//     return children;
// }

// export const AuthIsLoaded = () => {
//     const auth = useSelector((state: any) => state.firebase.auth);
//     if (!isLoaded(auth))
//       return (
//         <TodoLoading />
//       );
//     return children;
// }